import React from 'react';
import { motion } from 'framer-motion';
import Contact from '../components/Contact';

const ContactPage = ({ lang = 'en' }) => {
  const isAr = lang === 'ar';

  return (
    <div className='pt-32' dir={isAr ? 'rtl' : 'ltr'}>
      {/* Hidden SEO Header for Crawlers */}
      <div className='sr-only'>
        <h1>
          {isAr
            ? 'اتصل بنا - سوبر كلاسيكي الكويت'
            : 'Contact Us - Super Classy Kuwait'}
        </h1>
        <p>superclassykw mobile car wash contact and booking information.</p>
      </div>

      {/* Decorative Background for the Page */}
      <div className='absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-royal-purple-500/5 to-transparent -z-10' />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Passing the lang prop to the main Contact component */}
        <Contact lang={lang} />
      </motion.div>

      {/* Optional: Map or Location Placeholder Area */}
      <section className='section-padding pb-20'>
        <div className='max-w-7xl mx-auto'>
          <div className='h-64 md:h-96 w-full rounded-3xl overflow-hidden glass-card relative border border-white/10 shadow-2xl'>
            {/* You can replace this with a real Google Maps iframe later */}
            <div className='absolute inset-0 bg-gray-200 dark:bg-gray-800 flex items-center justify-center'>
              <div className='text-center p-8'>
                <div className='text-2xl font-black text-gradient mb-2'>
                  {isAr
                    ? 'نحن نغطي جميع مناطق الكويت'
                    : 'We Cover All Kuwait Areas'}
                </div>
                <p className='text-gray-500 font-medium'>
                  {isAr
                    ? 'من العاصمة إلى الجهراء، نصلك أينما كنت'
                    : 'From the City to Jahra, we reach you anywhere.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
